import styled from 'styled-components';

const Wrapper = styled.div`
  height: 100%;
`;

export default Wrapper;
